import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore'
import { Chart } from 'primereact/chart';
import IconButton from '@mui/material/IconButton';
import Backspace from '@mui/icons-material/ArrowBack';
//import './report.css';

export class AnalyticsProjectPieReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            prevProjects: [],
            projects: [],
            projectsByAnalyst: [],
            resultId: '',
            analyticId: ''
        };

        this.loadReport = this.loadReport.bind(this);
        this.loadByAnalystReport = this.loadByAnalystReport.bind(this);
        this.loadByStateReport = this.loadByStateReport.bind(this);
        //this.loadPeopleReport = this.loadPeopleReport.bind(this);
        this.onGraphClick = this.onGraphClick.bind(this);
        this.getRandomColor = this.getRandomColor.bind(this);
        this.onBackClick = this.onBackClick.bind(this);
        this.handleProjectEdit = this.handleProjectEdit.bind(this);
    }

    componentDidMount() {
        this.loadReport();
    }

    loadReport() {
        var scope = this;
        scope.setState({ loading: true });

        var token = localStorage.getItem("token");

        fetch('api/Report/GetAnalyticsProjectCounts', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ loading: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ projects: result, loading: false, isByAnalystReportLoaded: false, isByStateReportLoaded: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadByAnalystReport() {
        var scope = this;
        scope.setState({ loading: true });

        var token = localStorage.getItem("token");

        fetch('api/Report/GetAnalyticProjectStatesCounts?analyticId=' + this.state.analyticId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ loading: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ projects: result, loading: false, isByAnalystReportLoaded: true, isByStateReportLoaded: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadByStateReport() {
        var scope = this;
        scope.setState({ loading: true });

        var token = localStorage.getItem("token");

        fetch('api/Report/GetAnalyticProjectByState?analyticId=' + this.state.analyticId + '&state=' + this.state.state, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ loading: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ projects: result, loading: false, isByAnalystReportLoaded: false, isByStateReportLoaded: true });
                }).catch((err) => console.log(err));
            }
        });
    }

    convertData(records) {
        console.log(1);
        var data = {
            labels: [],
            datasets: [
                {
                    backgroundColor: [],
                    hoverBackgroundColor: [],
                    data: [],
                }
            ]
        };

        data.labels = records.map(r => r.name);
        data.datasets[0].data = records.map(r => r.count);
        data.datasets[0].backgroundColor = records.map(r => this.getRandomColor());
        data.datasets[0].hoverBackgroundColor = records.map(r => this.getRandomColor());

        return data;
    }

    onGraphClick(arg1, elements) {
        if (this.state.isByAnalystReportLoaded) {
            this.setState({ projectsByAnalyst: this.state.projects, state: this.state.projects[elements[0]._index].name }, this.loadByStateReport)
        }
        else if (this.state.isByStateReportLoaded) {
            this.handleProjectEdit(this.state.projects[elements[0]._index].id);
        }
        else {
            this.setState({ prevProjects: this.state.projects, analyticId: this.state.projects[elements[0]._index].analystId, analytic: this.state.projects[elements[0]._index].name }, this.loadByAnalystReport)
        }
        //!this.state.isDetailReportLoaded && this.setState({ presale: this.state.sales[elements[0]._index].isPresale, resultId: this.state.sales[elements[0]._index].key, isDetailReportLoaded: true }, this.loadDetailReport);
    }

    onBackClick() {
        if (this.state.isByAnalystReportLoaded) {
            this.setState({ projects: this.state.prevProjects, isByAnalystReportLoaded: false })
        }
        else if (this.state.isByStateReportLoaded) {
            this.setState({ projects: this.state.projectsByAnalyst, isByAnalystReportLoaded: true, isByStateReportLoaded: false })
        }
    }

    getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    handleProjectEdit(projectId) {
        var scope = this;
        scope.setState({ loading: true });
        var token = localStorage.getItem("token");
        fetch('api/Project/GetProjectMainInfo?id=' + projectId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ loading: false });
                    MainStore.openProjectDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        const options = {
            onClick: this.onGraphClick
        }

        return (
            <div>
                {(this.state.isByAnalystReportLoaded || this.state.isByStateReportLoaded) && <IconButton onClick={this.onBackClick} size="large">
                    <Backspace />
                </IconButton>}
                {this.state.isByAnalystReportLoaded && <div>{this.state.analytic}</div>}
                {this.state.isByStateReportLoaded && <div>{this.state.analytic} {this.state.state}</div>}
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <Chart type="pie" data={this.convertData(this.state.projects)} options={options}  />}
            </div>
        );
    }
}